import { render, staticRenderFns } from "./sk-checkbox.vue?vue&type=template&id=d1c4cb36&scoped=true&"
import script from "./sk-checkbox.vue?vue&type=script&lang=js&"
export * from "./sk-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./sk-checkbox.vue?vue&type=style&index=0&id=d1c4cb36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c4cb36",
  null
  
)

export default component.exports